<template>
  <div>
    <Suspense>
      <RouterView />
    </Suspense>
  </div>
</template>
